import React, { Component } from "react";
import BuildSettings from "../buildSettings";
import { connect } from "react-redux";
import { Selectors } from "../../data/permissions/duck";
import "./styles.css";

class PermissionNode extends Component {
	state = {
		isOpen: this.props.defaultOpen || false,
	};

	toggle = (e) => {
		e.stopPropagation();
		this.setState((prevState) => ({ isOpen: !prevState.isOpen }));
	};

  render() {
    const { name, data, ravens, tags } = this.props;
    const { isOpen } = this.state;
    const isParent = typeof data === 'object' && data !== null;

    if (isParent) {

        if (Object.keys(data).length === 0){
            return null;
        }

        return (
            <li key={name}>
            <strong onClick={this.toggle} className="collapsible">
                <span className="toggle-sign">{isOpen ? '[-]' : '[+]'}</span> {name}
            </strong>
            {isOpen && (
                <ul>
                {Object.entries(data).map(([key, value]) => {
                    let displayName = key;
                    if (name === 'byId') {
                    if (this.props.parentName === 'ravens' && ravens) {
                        const raven = ravens.find(r => r.ravenUuid === key);
                        if (raven && raven.vehicle && raven.vehicle.name) {
                        displayName = raven.vehicle.name;
                        }
                    } else if (this.props.parentName === 'tags' && tags) {
                        const tag = tags.find(t => t.tagId == key);
                        if (tag && tag.name) {
                        displayName = tag.name;
                        }
                    }
                    }
                    return <PermissionNode key={key} name={displayName} data={value} ravens={ravens} tags={tags} parentName={name}/>
                })}
                </ul>
            )}
            </li>
        );
    }

		return (
			<li key={name}>
				<strong>{name}:</strong> {String(data)}
			</li>
		);
	}
}

class PermissionsDebugger extends Component {
	state = {
		isOpen: false,
	};

	toggleDebugger = () => {
		this.setState((prevState) => ({ isOpen: !prevState.isOpen }));
	};

	render() {
		const { isOpen } = this.state;
		const { permissionsMap = {}, features = {}, ravens = [], tags = [] } = this.props;

		const authorizedEnv = ["dev", "qa", "test"];
		if (!authorizedEnv.includes(BuildSettings.environment())) {
			return null;
		}

        if(!ravens || !tags || !features) {
            // Data might not be ready on initial render, so we don't render the debugger yet.
            return null;
        }

		return (
			<div className={`permissions-debugger ${isOpen ? "open" : "closed"}`}>
				<button onClick={this.toggleDebugger} className="toggle-button">
					{isOpen ? "Close" : "Permissions"}
				</button>
				<div className="permissions-content">
					<h3>QA Inspector</h3>
					<ul>
						<PermissionNode
							name="Permissions"
							data={permissionsMap}
							ravens={ravens}
							tags={tags}
							defaultOpen={false}
						/>
						<PermissionNode
							name="Features"
							data={features}
							defaultOpen={false}
						/>
					</ul>
				</div>
			</div>
		);
	}
}

const mapStateToProps = (state) => ({
	tags: state.data.tags.list,
	permissionsMap: Selectors.getMap(state),
});

export default connect(mapStateToProps)(PermissionsDebugger);
